import React, { useState } from "react";
import "../../../styles/administration/main.css";
import { Link } from "react-router-dom";

const Main = () => {
    const [activeTab, setActiveTab] = useState("signup_form");

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <div className="administrationMain">
            <div className="administration">
                <div className="container mt-5">
                    <div className="row rounded-1">
                        <ul className="nav nav-tabs mt-3" id="myTab" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "signup_form1" ? "active" : ""
                                        }`}
                                    onClick={() => handleTabClick("signup_form1")}
                                    role="tab"
                                    aria-controls="signup_form1"
                                    aria-selected={activeTab === "signup_form1"}
                                >
                                    Administrative office
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "signup_form2" ? "active" : ""
                                        }`}
                                    onClick={() => handleTabClick("signup_form2")}
                                    role="tab"
                                    aria-controls="signup_form2"
                                    aria-selected={activeTab === "signup_form2"}
                                >
                                    Deans
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "signup_form3" ? "active" : ""
                                        }`}
                                    onClick={() => handleTabClick("signup_form3")}
                                    role="tab"
                                    aria-controls="signup_form3"
                                    aria-selected={activeTab === "signup_form3"}
                                >
                                    Wardens
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "signup_form4" ? "active" : ""
                                        }`}
                                    onClick={() => handleTabClick("signup_form4")}
                                    role="tab"
                                    aria-controls="signup_form4"
                                    aria-selected={activeTab === "signup_form4"}
                                >
                                    Deans Students Welfare
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "signup_form5" ? "active" : ""
                                        }`}
                                    onClick={() => handleTabClick("signup_form5")}
                                    role="tab"
                                    aria-controls="signup_form5"
                                    aria-selected={activeTab === "signup_form5"}
                                >
                                    Proctors
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "signup_form6" ? "active" : ""
                                        }`}
                                    onClick={() => handleTabClick("signup_form6")}
                                    role="tab"
                                    aria-controls="signup_form6"
                                    aria-selected={activeTab === "signup_form6"}
                                >
                                    Officer/Incharge
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "signup_form7" ? "active" : ""
                                        }`}
                                    onClick={() => handleTabClick("signup_form7")}
                                    role="tab"
                                    aria-controls="signup_form7"
                                    aria-selected={activeTab === "signup_form7"}
                                >
                                    Cell and Coordinators
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "signup_form" ? "active" : ""
                                        }`}
                                    onClick={() => handleTabClick("signup_form")}
                                    role="tab"
                                    aria-controls="signup_form"
                                    aria-selected={activeTab === "signup_form"}
                                >
                                    Engineering Section
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "signup_form8" ? "active" : ""
                                        }`}
                                    onClick={() => handleTabClick("signup_form8")}
                                    role="tab"
                                    aria-controls="signup_form8"
                                    aria-selected={activeTab === "signup_form8"}
                                >
                                    Dispensary
                                </button>
                            </li>
                        </ul>


                        <div className="tab-content" id="myTabContent">

                            {activeTab === "signup_form" && (
                                <div
                                    className="tab-pane fade show active"
                                    id="signup_form"
                                    role="tabpanel"
                                >
                                    <div className="more-boxes">
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://cdn.ccsuniversity.ac.in/cv/jpeg/manish%20mishra.jpeg" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Er. Manish Mishra</h1>
                                                <p>University Engineer</p>
                                                <Link
                                                    to={"#"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/dummy.webp" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Er. Vikas Tyagi</h1>
                                                <p>Electrical Engineer</p>
                                                <Link
                                                    to={"#"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://cdn.ccsuniversity.ac.in/cv/jpeg/manoj%20kumar.jpeg" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Er. Manoj Kumar</h1>
                                                <p>Junior Engineer (Civil)</p>
                                                <Link
                                                    to={"#"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                            {activeTab === "signup_form1" && (
                                <div
                                    className="tab-pane fade show active"
                                    id="signup_form1"
                                    role="tabpanel"
                                >
                                    <div className="more-boxes">
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/chancellor.png" alt="chancellor" />
                                            </div>
                                            <div className="content">
                                                <h1>Smt. Anandiben Patel</h1>
                                                <p>Hon'ble Chancellor</p>
                                                <Link to={"#"} className="pdf-link" rel="noreferrer" target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/vc-img.jpg" alt="Vice-Chancellor" />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Sangeeta Shukla</h1>
                                                <p>Hon'ble Vice-Chancellor</p>
                                                <Link to={"#"} className="pdf-link" rel="noreferrer" target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/administration/mk_gupta.jpg" alt="Prof. M.K. Gupta" />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. M.K. Gupta</h1>
                                                <p>Pro Vice-Chancellor</p>
                                                <Link to={"#"} className="pdf-link" rel="noreferrer" target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/administration/finance-controller-ramesh-chandra.jpg" alt="Ramesh Chandra" />
                                            </div>
                                            <div className="content">
                                                <h1>Sh. Ramesh Chandra</h1>
                                                <p>Finance Officer/ Director Finance</p>
                                                <Link to={"#"} className="pdf-link" rel="noreferrer" target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="box-faculty">
                                                                                    <div className="image">
                                                                                        <img src="https://cdn.ccsuniversity.ac.in/public/webp/2026/09/ajay%20kumar%20yadav.webp" alt="Registrar" />
                                                                                    </div>
                                                                                    <div className="content">
                                                                                        <h1>Shri Ajay Kumar Yadav</h1>
                                                                                        <p>Registrar</p>
                                                                                        <Link to={""} className="pdf-link" rel="noreferrer" target="_blank">
                                                                                            View resume
                                                                                        </Link>
                                                                                    </div>
                                                                                </div>

                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://cdn.ccsuniversity.ac.in/public/webp/2026/09/ajay%20kumar%20yadav.webp" alt="COE" />
                                            </div>
                                            <div className="content">
                                                <h1>Shri Ajay Kumar Yadav</h1>
                                                <p>Controller of Examination</p>
                                                <Link to={"#"} className="pdf-link" rel="noreferrer" target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/satyaprakash Singh.jpeg" alt="Satyaprakash Singh" />
                                            </div>
                                            <div className="content">
                                                <h1>Satyaprakash Singh</h1>
                                                <p>Dy. Registrar Examination</p>
                                                <Link to={"#"} className="pdf-link" rel="noreferrer" target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>

                                        {/* <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/vikas.jpg" alt="Shri Vikas" />
                                            </div>
                                            <div className="content">
                                                <h1>Shri Vikas</h1>
                                                <p>Dy. Registrar</p>
                                                <Link to={"#"} className="pdf-link" rel="noreferrer" target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div> */}

                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpg/P131.jpg" alt="Prof. Bhupendra Singh" />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Bhupendra Singh</h1>
                                                <p>Dean Student Welfare</p>
                                                <a href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R131.pdf" className="pdf-link" rel="noreferrer" target="_blank">
                                                    View resume
                                                </a>
                                            </div>
                                        </div>

                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/administration/prof-beerpal.jpg" alt="Prof. Beer Pal Singh" />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Beer Pal Singh</h1>
                                                <p>Proctor</p>
                                                <a href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R6.pdf" className="pdf-link" rel="noreferrer" target="_blank">
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                            {activeTab === "signup_form2" && (
                                <div
                                    className="tab-pane fade show active"
                                    id="signup_form2"
                                    role="tabpanel"
                                >
                                    <div className="more-boxes">
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://cdn.ccsuniversity.ac.in/cv/jpg/P66.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Rahul Kumar</h1>
                                                <p>Agriculture</p>
                                                <a
                                                    href="https://cv.ccsuniversity.ac.in/?id=22010051"
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://cdn.ccsuniversity.ac.in/cv/jpg/atvir-sir.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Atvir Singh</h1>
                                                <p>Arts</p>
                                                <a
                                                    href="https://cv.ccsuniversity.ac.in/?id=22010062"
                                                    className="pdf-link"
                                                    rel='noreferrer'
                                                    target="_blank"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/dummy.webp" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Vinita Tyagi</h1>
                                                <p>Ayurveda</p>
                                                <Link to={"#"} className="pdf-link" rel='noreferrer' target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpeg/rakesh-kumar-sharma.jpeg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Rakesh Sharma</h1>
                                                <p>Education</p>
                                                <Link
                                                    to={"#"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://cdn.ccsuniversity.ac.in/cv/webp/bhisham%20kapoor.webp" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. (Dr.) Bhisham Kapoor</h1>
                                                <p>Commerce and Management</p>
                                                <Link
                                                    to={"https://cdn.ccsuniversity.ac.in/cv/pdf/DocScanner%201%20Sept%202026%2014-23.pdf"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://cdn.ccsuniversity.ac.in/cv/jpg/P120.jpg" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. R.K. Soni</h1>
                                                <p>Engineering &amp; Technology</p>
                                                <a
                                                    href="https://cv.ccsuniversity.ac.in/?id=22010066"
                                                    className="pdf-link"
                                                    rel='noreferrer'
                                                    target="_blank"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src=""
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Pankaj Tyagi</h1>
                                                <p>Law</p>
                                                <Link
                                                    to={"#"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/dummy.webp" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. R.C. Gupta</h1>
                                                <p>Medicine</p>
                                                <Link
                                                    to={"#"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://www.llrmmedicalcollege.edu.in/assets/setting/drvibhusahni1.jpg" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Vibhu Sahani</h1>
                                                <p>Pharmacy</p>
                                                <Link to={"#"} className="pdf-link" rel='noreferrer' target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://cdn.ccsuniversity.ac.in/cv/jpg/P129.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Hare Krishna</h1>
                                                <p>Science</p>
                                                <a
                                                    href="https://cv.ccsuniversity.ac.in/?id=22010167"
                                                    className="pdf-link"
                                                    rel='noreferrer'
                                                    target="_blank"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === "signup_form3" && (
                                <div
                                    className="tab-pane fade show active"
                                    id="signup_form3"
                                    role="tabpanel"
                                >
                                    <div id='wardenn'>
                                        <div className="more-boxes">
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="../../assets/images/administration/Dinesh Kumar.png"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Prof. Dinesh Kumar</h1>
                                                    <p>Chief Warden</p>
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R3520220701114011.pdf"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <h3 className="my-heading">Dr. A. P. J. Abdul Kalam (Boys) Hostel</h3>
                                        <div className="more-boxes">
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="../../assets/images/administration/Pravin Kumar.png"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Er. Pravin Kumar</h1>
                                                    <p>Warden</p>
                                                    <a
                                                        href="#"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/gaurav-tyagi.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Gaurav Tyagi</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/Lakshmi-singh.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Lakshmi Shanker Singh</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <h3 className="my-heading">Dr. B.R. Ambedkar (Boys) Hostel</h3>
                                        <div className="more-boxes">
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/yp-singh.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Y.P. Singh</h1>
                                                    <p>Warden</p>
                                                    <a
                                                        href=""
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img src="../../assets/images/administration/ajay_kumar.jpg" alt="" />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Ajay Kumar</h1>
                                                    <p>Assistant Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <h3 className="my-heading">Dr. Kailash Prakash (Boys) Hostel</h3>
                                        <div className="more-boxes">
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="../../assets/images/administration/Dr. Sachin Kumar.png"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Sachin Kumar</h1>
                                                    <p>Warden</p>
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R5220221016034034.pdf"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/Pankaj.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Pankaj Kumar</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a href="#" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src=""
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Munesh Kumar</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a href="#" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <h3 className="my-heading">Dr. R.K. Singh (Boys) Hostel</h3>
                                        <div className="more-boxes">
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/P209.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Prof. Sanjeev Kumar</h1>
                                                    <p>Warden</p>
                                                    <a
                                                        href="https://cv.ccsuniversity.ac.in/?id=22010309"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/P128.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Anil Kumar Yadav</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R12820221016070326.pdf"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/JR-bentham.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Er. J.R. Bentham</h1>
                                                    <p>Assistant Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

<h3 className="my-heading">Arya Bhatt Hostel</h3>
                                        <div className="more-boxes">
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/kp-singh.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. K.P. Singh</h1>
                                                    <p>Warden</p>
                                                    <a href="#" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/Shivam.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Shivam Goyal</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a
                                                        href="#"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <h3 className="my-heading">Durga Bhabhi Girls Hostel</h3>
                                        <div className="more-boxes">
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpg/P53.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Saru Kumari</h1>
                                                    <p>Warden</p>
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R5320220108082745.pdf"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="../../assets/images/administration/nidhi_bhatia.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Smt. Nidhi Bhatia</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="../../assets/images/administration/Dr. NAZIA TARANNUM.png"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Nazia Tarannum</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R2520220315080441.pdf"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <h3 className="my-heading">Pt. Deen Dayal Upadhyay (Boys) Hostel</h3>
                                        <div className="more-boxes">
                                            {/* <div className="box-faculty">
                                                <div className="image">
                                                    <img src="../../assets/images/administration/cp_singh.jpg" alt="" />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. C.P. Singh</h1>
                                                    <p>Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div> */}
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="../../assets/images/administration/vijay_kumar_ram.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Er. Vijay Kumar Ram</h1>
                                                    <p>Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img src="../../assets/images/administration/vijay_singh.jpg" alt="" />
                                                </div>
                                                <div className="content">
                                                    <h1>Er. Vijay Singh</h1>
                                                    <p>Assistant Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img src="https://cdn.ccsuniversity.ac.in/cv/jpg/Priyank.jpg" alt="" />
                                                </div>
                                                <div className="content">
                                                    <h1>Er. Priyank Sirohi</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <h3 className="my-heading">Rani Lakshmi Bai Girls Hostel</h3>
                                        <div className="more-boxes">
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="../../assets/images/administration/bindu-sharma.png"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Prof. Bindu Sharma</h1>
                                                    <p>Warden</p>
                                                    <a
                                                        href="https://cv.ccsuniversity.ac.in/?id=22010171"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="../../assets/images/administration/divya_sharma.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Smt. Divya Sharma</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a
                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R19920220315074600.pdf"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img src="../../assets/images/administration/vandana.jpg" alt="" />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Vandana</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <h3 className="my-heading">V.S Maharana Pratap (Boys) Hostel</h3>
                                        <div className="more-boxes">
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/yeshvandra.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Yeshvandra Verma</h1>
                                                    <p>Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/Yogendra-gautam.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Yogendra Gautam</h1>
                                                    <p>Asstt. Warden</p>
                                                    <a
                                                        href="#"
                                                        className="pdf-link"
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="box-faculty">
                                                <div className="image">
                                                    <img
                                                        src="https://cdn.ccsuniversity.ac.in/cv/jpg/Amrish.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="content">
                                                    <h1>Dr. Amrish Kumar</h1>
                                                    <p>Assistant Warden</p>
                                                    <a href="##" className="pdf-link" target="_blank" rel="noreferrer">
                                                        View resume
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                            {activeTab === "signup_form4" && (
                                <div
                                    className="tab-pane fade show active"
                                    id="signup_form4"
                                    role="tabpanel"
                                >
                                    <div className="more-boxes">
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpg/P131.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Bhupendra Singh</h1>
                                                <p>Dean Student Welfare</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R131.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpg/P39.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Shiv Raj Singh</h1>
                                                <p>Assistant Dean, Students Welfare</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R39.pdf"
                                                    className="pdf-link"
                                                    rel='noreferrer'
                                                    target="_blank"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="../../assets/images/administration/Prof. Neelu Jain Gupta.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Neelu Jain Gupta</h1>
                                                <p>Assistant Dean, Students Welfare</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R4020220111054918.pdf"
                                                    className="pdf-link"
                                                    rel='noreferrer'
                                                    target="_blank"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="../../assets/images/administration/ANIL KUMAR MALIK.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Anil Malik</h1>
                                                <p>Assistant Dean, Students Welfare</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R41.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://cdn.ccsuniversity.ac.in/cv/jpg/P124.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Anuj kumar</h1>
                                                <p>Assistant Dean, Students Welfare</p>
                                                <a
                                                    href="https://cv.ccsuniversity.ac.in/?id=22010015"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpg/P42.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Y.P. Singh</h1>
                                                <p>Assistant Dean, Students Welfare</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R4220221018073059.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/dummy.webp" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Santosh Prasad Singh</h1>
                                                <p>Assistant Dean, Students Welfare</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R4320220315075445.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="../../assets/images/administration/RAHUL KUMAR.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Rahul Kumar</h1>
                                                <p>Assistant Dean, Students Welfare</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R66.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}



                            {activeTab === "signup_form5" && (
                                <div
                                    className="tab-pane fade show active"
                                    id="signup_form5"
                                    role="tabpanel"
                                >
                                    <div className="more-boxes">
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/administration/prof-beerpal.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Beer Pal Singh</h1>
                                                <p>Proctor</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R6.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpg/P138.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Ravindra Kumar</h1>
                                                <p>Assistant Proctor</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R44.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpg/P39.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Shiv Raj Singh</h1>
                                                <p>Assistant Proctor</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R39.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="../../assets/images/administration/DR. ASHOK KUMAR.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Ashok Kumar</h1>
                                                <p>Assistant Proctor</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R4620221001110551.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="../../assets/images/administration/dharmendra pratap.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Dharmendra Pratap Singh</h1>
                                                <p>Assistant Proctor</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R47.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://cdn.ccsuniversity.ac.in/cv/jpg/P24.jpg" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Dushyant Kumar Chauhan</h1>
                                                <p>Assistant Proctor</p>
                                                <Link to={"#"} className="pdf-link" rel='noreferrer' target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="../../assets/images/administration/Dr. NAZIA TARANNUM.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Nazia Tarannum</h1>
                                                <p>Assistant Proctor</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R2520220315080441.pdf"
                                                    className="pdf-link"
                                                    rel='noreferrer'
                                                    target="_blank"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpg/P50.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Pradeep Chaudhary</h1>
                                                <p>Assistant Proctor</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R50.pdf"
                                                    className="pdf-link"
                                                    rel='noreferrer'
                                                    target="_blank"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="../../assets/images/administration/Pravin Kumar.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Er. Pravin Kumar</h1>
                                                <p>Assistant Proctor</p>
                                                <a
                                                    href="#"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="../../assets/images/administration/Dr. Sachin Kumar.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Sachin Kumar</h1>
                                                <p>Assistant Proctor</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R5220221016034034.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpg/P53.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Saru Kumari</h1>
                                                <p>Assistant Proctor</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R5320220108082745.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="https://cdn.ccsuniversity.ac.in/cv/jpg/P54.jpg" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. Yeshvandra Verma</h1>
                                                <p>Assistant Proctor</p>
                                                <Link to={"#"} className="pdf-link" rel='noreferrer' target="_blank">
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                            {activeTab === "signup_form6" && (
                                <div
                                    className="tab-pane fade show active"
                                    id="signup_form6"
                                    role="tabpanel"
                                >
                                    <div className="more-boxes">
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/administration/sanjay-kumar-bhardwaj.jpg" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Sanjay Kumar Bhardwaj</h1>
                                                <p>Incharge Computer Center</p>
                                                <Link
                                                    to={"#"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                                                                    <div className="image">
                                                                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/cv/jpg/P131.jpg" alt="Registrar" />
                                                                                    </div>
                                                                                    <div className="content">
                                                                                        <h1>Prof. Bhupendra Singh</h1>
                                                                                        <p>Registrar</p>
                                                                                        <Link to={"https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R131.pdf"} className="pdf-link" rel="noreferrer" target="_blank">
                                                                                            View resume
                                                                                        </Link>
                                                                                    </div>
                                                                                </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/administration/prof-beerpal.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Beer Pal Singh</h1>
                                                <p>Incharge Security</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R6.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="../../assets/images/administration/DR. GULAB SINGH RUHAL.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. G.S. Ruhal</h1>
                                                <p>University Sports Officer</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R3720220704055817.pdf"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="../../assets/images/administration/bindu-sharma.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Bindu Sharma</h1>
                                                <p>Incharge Website</p>
                                                <a
                                                    href="https://cv.ccsuniversity.ac.in/?id=22010171"
                                                    className="pdf-link"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/administration/sanjay-kumar-bhardwaj.jpg" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Sanjay Kumar Bhardwaj</h1>
                                                <p>Vigilance Officer</p>
                                                <a
                                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R57.pdf"
                                                    className="pdf-link"
                                                    rel='noreferrer'
                                                    target="_blank"
                                                >
                                                    View resume
                                                </a>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/dummy.webp" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Sanjeev Sharma</h1>
                                                <p>Director Academics</p>
                                                <Link
                                                    to={"#"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img
                                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/administration/prof-beerpal.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="content">
                                                <h1>Prof. Beer Pal Singh</h1>
                                                <p>Director Research</p>
                                                <Link
                                                    to={"#"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}



                            {activeTab === "signup_form7" && (
                                <div
                                    className="tab-pane fade show active"
                                    id="signup_form7"
                                    role="tabpanel"
                                >
                                    <div className="more-boxes">
                                                                            <div className="box-faculty">
                                                                                <div className="image">
                                                                                    <img
                                                                                        src="../../assets/images/administration/Dinesh Kumar.png"
                                                                                        alt=""
                                                                                    />
                                                                                </div>
                                                                                <div className="content">
                                                                                    <h1>Prof. Dinesh Kumar</h1>
                                                                                    <p>Kashi Ram Shodh Peeth</p>
                                                                                    <a
                                                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R3520220701114011.pdf"
                                                                                        className="pdf-link"
                                                                                        target="_blank"
                                                                                        rel='noreferrer'
                                                                                    >
                                                                                        View resume
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                            <div className="box-faculty">
                                                                                <div className="image">
                                                                                    <img src="https://cdn.ccsuniversity.ac.in/cv/jpg/P157.jpg" alt="" />
                                                                                </div>
                                                                                <div className="content">
                                                                                    <h1>Prof. Sanjeev Kumar Sharma</h1>
                                                                                    <p>Pt. Deen Dayal Upadhyay Shodh Peeth</p>
                                                                                    <Link to={"#"} className="pdf-link" rel='noreferrer' target="_blank">
                                                                                        View resume
                                                                                    </Link>
                                                                                </div>
                                                                            </div>
                                                                            <div className="box-faculty">
                                                                                <div className="image">
                                                                                    <img
                                                                                        src="../../assets/images/administration/Dinesh Kumar.png"
                                                                                        alt=""
                                                                                    />
                                                                                </div>
                                                                                <div className="content">
                                                                                    <h1>Prof. Dinesh Kumar</h1>
                                                                                    <p>SC/ST Cell</p>
                                                                                    <a
                                                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R3520220701114011.pdf"
                                                                                        className="pdf-link"
                                                                                        target="_blank"
                                                                                        rel='noreferrer'
                                                                                    >
                                                                                        View resume
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                            <div className="box-faculty">
                                                                                <div className="image">
                                                                                    <img
                                                                                        src="../../assets/images/administration/Prof. Jaimala.png"
                                                                                        alt=""
                                                                                    />
                                                                                </div>
                                                                                <div className="content">
                                                                                    <h1>Prof. Jaimala</h1>
                                                                                    <p>Women Cell</p>
                                                                                    <a
                                                                                        href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/Resume/R15.pdf"
                                                                                        className="pdf-link"
                                                                                        target="_blank"
                                                                                        rel='noreferrer'
                                                                                    >
                                                                                        View resume
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                            <div className="box-faculty">
                                                                                <div className="image">
                                                                                    <img
                                                                                        src="../../assets/images/administration/bindu-sharma.png"
                                                                                        alt=""
                                                                                    />
                                                                                </div>
                                                                                <div className="content">
                                                                                    <h1>Prof. Bindu Sharma</h1>
                                                                                    <p>Convener Women Adhyayan Kendra</p>
                                                                                    <a
                                                                                        href="https://cv.ccsuniversity.ac.in/?id=22010171"
                                                                                        className="pdf-link"
                                                                                        target="_blank"
                                                                                        rel='noreferrer'
                                                                                    >
                                                                                        View resume
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                            <div className="box-faculty">
                                      <div className="image">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/administration/prof-beerpal.jpg" alt="Beerpal Sir" />
                                      </div>
                                      <div className="content">
                                        <h1>Prof. Beer Pal Singh</h1>
                                        <p>International Coorporation</p>
                                        <a href="#" className="pdf-link" target="_blank" rel="noreferrer">View resume</a>
                                      </div>
                                    </div>
                                    
                                    <div className="box-faculty">
                                      <div className="image">
                                        <img src="https://cdn.ccsuniversity.ac.in/cv/jpg/P64.jpg" alt="Prof. SS Gaurav" />
                                      </div>
                                      <div className="content">
                                        <h1>Prof. SS Gaurav</h1>
                                        <p>Placement Cell</p>
                                        <a href="#" className="pdf-link" target="_blank" rel="noreferrer">View resume</a>
                                      </div>
                                    </div>
                                    
                                    <div className="box-faculty">
                                      <div className="image">
                                        <img src="https://cdn.ccsuniversity.ac.in/cv/jpg/P64.jpg" alt="Prof. SS Gaurav" />
                                      </div>
                                      <div className="content">
                                        <h1>Prof. SS Gaurav</h1>
                                        <p>ABACUS-UP</p>
                                        <a href="#" className="pdf-link" target="_blank" rel="noreferrer">View resume</a>
                                      </div>
                                    </div>
                                    
                                    <div className="box-faculty">
                                      <div className="image">
                                        <img src="https://cdn.ccsuniversity.ac.in/cv/jpg/P124.jpg" alt="Dr. Anuj Kumar" />
                                      </div>
                                      <div className="content">
                                        <h1>Dr. Anuj Kumar</h1>
                                        <p>Aishe</p>
                                        <a href="#" className="pdf-link" target="_blank" rel="noreferrer">View resume</a>
                                      </div>
                                    </div>
                                    
                                    
                                    <div className="box-faculty">
                                      <div className="image">
                                        <img src="https://cdn.ccsuniversity.ac.in/cv/jpg/P171.jpg" alt="Dr. Mukesh Kumar Sharma" />
                                      </div>
                                      <div className="content">
                                        <h1>Dr. Mukesh Kumar Sharma</h1>
                                        <p>UG Cell</p>
                                        <a href="#" className="pdf-link" target="_blank" rel="noreferrer">View resume</a>
                                      </div>
                                    </div>
                                    
                                                                        </div>
                                </div>
                            )}



                            {activeTab === "signup_form8" && (
                                <div
                                    className="tab-pane fade show active"
                                    id="signup_form8"
                                    role="tabpanel"
                                >
                                    <div className="more-boxes">
                                        <div className="box-faculty">
                                            <div className="image">
                                                <img src="../../assets/images/dummy.webp" alt="" />
                                            </div>
                                            <div className="content">
                                                <h1>Dr. P.K. Bansal</h1>
                                                <p>University Doctor</p>
                                                <Link
                                                    to={"#"}
                                                    className="pdf-link"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                    View resume
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="organogram pt-5">
                    <div className="wrapper">
                        <div className="container">
                            <h2>ORGANOGRAM</h2>
                            <p>Organogram of Chaudhary Charan Singh University, Meerut</p>
                            <img src="..\assets\images\organogram.jpg" alt="Organogram" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
